import { Token, UserProfile } from 'types/api'

export interface TokenRefresh {
  access: string
  refresh: string
}

export interface CustomTokenObtainPair {
  username: string
  password: string
}

export interface CustomTokenRefresh {
  refresh: string
}

export interface StoredUser {
  accessToken: string
  refreshToken: string
  lastRefresh: number
  expiresAt: number
}

export enum AuthenticationStatus {
  Loading = 'loading',
  LoggedIn = 'loggedIn',
  LoggedOut = 'loggedOut'
}

export type AuthenticationContextType = {
  user: StoredUser | undefined
  role: UserProfile['role'] | undefined
  loginSatus: AuthenticationStatus
  setUser: (tokens: Token) => void
  logout: () => void
}

export interface UserCreateInput {
  email: string
  first_name: string
  last_name: string
  referral_code?: string
  phone: string
}

export interface ForgottenPasswordCreateNewPassword {
  token: string
  password: string
  password_confirmation: string
}

export interface NewPassword {
  token: string
  password: string
  password_confirmation: string
}

export interface ForgottenPasswordCreate {
  email: string
}
